<template>
  <div class="card card-content">
    <h6>Month 0 Gene Xpert</h6>
    <form>
      <div class="row">
        <div class="input-field col s12">
          <div class="switch">
            <label>
              Not Done
              <input type="checkbox" @click="switchChange" />
              <span class="lever"></span>
              Done
            </label>
          </div>
        </div>
        <div class="input-field col s12" v-show="done == 1">
        <span>Type of Gene Xpert</span>
        <select v-model="gxp_ultra">
          <option value="1" selected>GXP</option>
          <option value="2" selected>GXP Ultra</option>
        </select>
      </div>
        <div class="input-field col s12">
          <span>Date of Gene Xpert examination</span>
          <input
            type="text"
            placeholder="YYYY-MM-DD"
            v-model.lazy="date"
            class="datepicker"
            :disabled="!done"
            readonly
          />
        </div>
        <div class="input-field col s12" v-show="done">
          <span>Result of Gene Xpert</span>
          <select v-model="result">
            <option value="" disabled selected>Choose your option</option>
            <option
            v-for="option in resultOptions"
            :value="option.value"
            :key="option.value"
            >{{ option.label }}</option
          >
          </select>
        </div>

        <div class="row center">
          <button
            type="button"
            class="btn blue darken-3"
            @click="submit"
            :disabled="updateloading"
            v-if="buttonpass"
          >
            Edit
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "NewGeneXpert",
  data() {
    return {
      done: false,
      gxp_ultra: null,
      date: "",
      result: "",
      resultOptions: [
      { label: "N-MTB not detected", value: "1" },
      { label: "T-MTB detected", value: "2" },
      { label: "RR-Rif resistance", value: "3" },
      { label: "Tl-MTB detected, RR indeterminate", value: "4" },
      { label: "l-invalid result", value: "5" },
      { label: "Missing", value: "6" },
      { label: "Pending", value: "7" },
      { label: "TT-MTB detected (trace)", value: "8" },
    ]
    };
  },
  mounted() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems, {});

    var elems = document.querySelectorAll(".datepicker");
    var instances = M.Datepicker.init(elems, {
      format: "yyyy-mm-dd",
      showClearBtn: true,
    });
  },
  watch: {
    updateloading(newVal) {
      if (!newVal) {
        location.reload();
      }
    },
  },
  methods: {
    switchChange() {
      this.done = this.done == 0 ? 1 : 0;
      if (this.done == 1) {
        localStorage.setItem("current_data", "changed");
      } else {
        localStorage.setItem("current_data", null);
      }
    },

    submit() {
      var data = {
        done: this.done,
        date: null,
        result: null,
      };

      if (this.done) {
        data.date = this.date;
        data.result = this.result;
        data.gxp_ultra = this.gxp_ultra;
      }

      data.id = this.patient.id;

      this.$store.dispatch("submitGeneExpert", data);
    },
  },
  components: {},
  computed: {
    patient() {
      return this.$store.getters.patient;
    },

    buttonpass() {
      if (this.done) {
        if (this.result && this.date) {
          return true;
        } else if (this.result == 7) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    updateloading() {
      return this.$store.getters.updateloading;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fill {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 5px;
}

.fill .card {
  padding: 20px;
}
</style>
